import { render, staticRenderFns } from "./MemberFilterJudgeLayout.vue?vue&type=template&id=6bd4c864&scoped=true"
import script from "./MemberFilterJudgeLayout.vue?vue&type=script&lang=js"
export * from "./MemberFilterJudgeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4c864",
  null
  
)

export default component.exports